import React from "react";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import IconClear from "@material-ui/icons/Clear";
import IconDone from "@material-ui/icons/Done";

import CustomAutoCompleteFilter from "../../lib/components/customdatagridfilter/CustomFilter";
import { creditorsPaymentTerms } from "../../lib/api/creditorspaymentterms";
import { CreditorsInvoiceType } from "../../lib/api/creditorsinvoicetype";
import { CellActionsFormatter } from "../../lib/helpers/CellActionsFormatter";

import { handleColumnsWidth, handleColumnsArrangement } from "../../lib/helpers/grid";

const cellWidthTiny = 40;
const cellWidthXtraSmall = 70;
const cellWidthSmall = 80;
const cellWidthSmallBig = 140;
const cellWidthMedium = 200;
// const cellWidthLarge = 250;
const cellWidthXtrLarge = 350;

const defaultColumnProperties = {
  resizable: true,
  sortable: true,
};

const PaymentTermField = ({ row, column }) => {
  const data = row[column.key];
  const paymentTerm = creditorsPaymentTerms.find((term) => term.id === data);
  return <div>{paymentTerm ? paymentTerm.name : ""}</div>;
};

const ConsolidationApplyField = ({ row, column }) => {
  const data = row[column.key];
  const consoleterm = CreditorsInvoiceType[data]; //CreditorsInvoiceType);

  return <div>{consoleterm ? consoleterm : ""}</div>;
};

export const activecheck = ({ row, column }) => {
  const value = row[column.key];
  if (value) {
    return <IconDone style={{ color: "green" }} />;
  }
  return <IconClear style={{ color: "red" }} />;
};

let currentSpace = true;
export const GridColumns = (data, filters, arrangement, columnsWidth, handleRemove, handleEdit) => {
  let postValue = "";

  if (data) {
    if (currentSpace) {
      postValue = " ";
    }
    currentSpace = !currentSpace;
  }

  const columns = [
    {
      key: "actions",
      name: "Actions",
      width: cellWidthSmall,
      formatter: ({ row }) => {
        const actions = cellActions(row, handleRemove, handleEdit);
        return (
          <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
            <CellActionsFormatter actions={actions} />
          </div>
        );
      },
    },
    {
      key: "active",
      name: "Active",
      width: cellWidthXtraSmall,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"active"} data={data} section={"maintenancecreditors"} />;
      },
      formatter: activecheck,
    },
    {
      key: "code",
      name: "Code" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"code"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "name",
      name: "Name" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"name"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "physical_address",
      name: "Physical Address" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"physical_address"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "postal_address",
      name: "Postal Address" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"postal_address"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "telephone",
      name: "Telephone" + postValue,
      width: cellWidthSmallBig,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"telephone"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "email",
      name: "Email" + postValue,
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"email"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "vat_number",
      name: "Vat Number" + postValue,
      width: cellWidthSmallBig,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"vat_number"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "creditorsgroup_description",
      name: "Group" + postValue,
      width: cellWidthSmallBig,
      filterable: true,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"creditorsgroup_description"} data={data} section={"maintenancecreditors"} />
        );
      },
    },
    {
      key: "creditorsgroupsub_group",
      name: "Sub Group" + postValue,
      width: cellWidthSmallBig,
      filterable: true,
      filterRenderer: (e) => {
        return (
          <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"creditorsgroupsub_group"} data={data} section={"maintenancecreditors"} />
        );
      },
    },
    {
      key: "contact_person",
      name: "Contact Person" + postValue,
      width: cellWidthSmallBig,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"contact_person"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "currency_code",
      name: "Currency" + postValue,
      width: cellWidthXtraSmall,
      filterable: true,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"currency_code"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "payment_term_id",
      name: "Payment Term" + postValue,
      width: cellWidthMedium,
      filterable: true,
      formatter: PaymentTermField,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"payment_term_id"} data={data} section={"maintenancecreditors"} />;
      },
    },
    {
      key: "consolidationapply",
      name: "Consolidation Apply" + postValue,
      width: cellWidthMedium,
      filterable: true,
      formatter: ConsolidationApplyField,
      filterRenderer: (e) => {
        return <CustomAutoCompleteFilter {...e} multiSelection={true} currentFilters={filters} fieldname={"consolidationapply"} data={data} section={"maintenancecreditors"} />;
      },
    },
  ].map((c) => ({ ...c, ...defaultColumnProperties }));

  let columnsArranged = [];

  columnsArranged = handleColumnsArrangement(columnsArranged, arrangement, columns);
  columnsArranged = handleColumnsWidth(columnsArranged, columnsWidth, columns);

  return columnsArranged;
};

const cellActions = (order, handleRemove, handleEdit) => {
  return [
    {
      icon: (
        <span title="Edit">
          <EditIcon style={{ cursor: "pointer", color: "orange" }} />
        </span>
      ),
      callback: (e) => {
        handleEdit(order.id);
      },
    },
    {
      icon: (
        <span title="Remove">
          <DeleteIcon style={{ cursor: "pointer", color: "red" }} />
        </span>
      ),
      callback: (e) => {
        handleRemove(order.id);
      },
    },
  ];
};
